import { footerConfig } from "@/shared/config/footer.config";
import { Footer } from "@/widgets/layout";
import { GamesSidebar } from "@/widgets/layout/sidebar/ui/GamesSidebar";
import { observer } from "mobx-react-lite";
import React from "react";
import styles from "./GameLayout.module.css";

interface GameLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  isCompact?: boolean;
}

export const GameLayout: React.FC<GameLayoutProps> = observer(
  ({ children, isLoading = false, isCompact = false }) => {
    if (isLoading) {
      return (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingText}>Загрузка...</div>
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <GamesSidebar logoAlt="Games Portal" />
        <div className={styles.main}>
          <main className={styles.content}>{children}</main>
          <Footer data={footerConfig} isCompact={isCompact} />
        </div>
      </div>
    );
  }
);
